import loader from '../core/loader'
const _qqSDK = '//open.mobile.qq.com/sdk/qqapi.wk.js?_bid=152'

export function qqReady (cb) {
  loader.sdkReady('mqq', _qqSDK, sdk => {
    cb(sdk)
  })
}
